import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Divider,
  FormControl,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Snackbar,
  TextField,
  TextareaAutosize,
  FormGroup,
} from '@mui/material';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getBeers, loadBeersRequest } from '../../../redux/beersRedux';
import { getUser } from '../../../redux/usersRedux';
import {
  generateExpirationDateFromBatch,
  generateProductionDateFromBatch,
} from '../../../utils/generateExpirationDateFromBatch';
import 'dayjs/locale/pl';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { loadBinsByWarehouseRequest } from '../../../redux/binsRedux';

const typesReport = [
  { value: 'KWARANTANNA', label: 'Kwarantanna' },
  { value: 'PODEJRZENIE_NIEZGODNOSCI', label: 'Podejrzenie niezgodności' },
  { value: 'RAPORT_NIEZGODNOSCI', label: 'Raport niezgodności' },
];

const reasons = [
  { value: 'MIKROBIOLOGIA', label: 'Mikrobiologia' },
  { value: 'FIZ_CHEM', label: 'Fiz/Chem' },
];

const typesLocks = [
  { value: 'CALE_ZLECENIE', label: 'Całe zlecenie' },
  {
    value: 'BLOKADA_GODZIN',
    label: 'Blokada godzinowa',
  },
  {
    value: 'BLOKADA_BINOW',
    label: 'Blokada binów',
  },
  {
    value: 'BLOKADA_SSCC',
    label: 'Blokada SSCC',
  },
];
const ReportPZ04Form = ({ action, actionText, props }) => {
  const user = useSelector((state) => getUser(state));
  const handleTypesReport = (value) => {
    const type = typesReport.filter((el) => el.value === value);
    return type[0].label;
  };
  const handleReasons = (value) => {
    const reason = reasons.filter((el) => el.value === value);
    return reason[0].label;
  };

  const handleTypeLocks = (value) => {
    const type = typesLocks.filter((el) => el.value === value);
    return type[0].label;
  };

  const handleTypeLock = async (value) => {
    if (value === 'BLOKADA_BINOW') {
      const res = await dispatch(
        loadBinsByWarehouseRequest(user.users.warehouse),
      );
      setBinList(res.data);
    }
  };

  const handleSelectedBins = (bins) => {
    const selected = [];
    bins.map((el) => {
      selected.push({
        id: el.binListId,
        binName: el.binList.binName,
        warehouse: el.binList.warehouse,
      });
    });

    return selected;
  };

  const handleSSCCList = (sscc) => {
    const newSscc = [];
    sscc.map((el) => {
      newSscc.push(el.sscc);
    });
    return newSscc;
  };

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [alert, setAlert] = useState(false);

  const [typeReport, setTypeReport] = useState(props ? props.typeReport : '');
  const [typeReportDes, setTypeReportDes] = useState(
    props ? handleTypesReport(props.typeReport) : '',
  );
  const [reason, setReason] = useState(props ? props.reason : '');
  const [reasonDes, setReasonDes] = useState(
    props ? handleReasons(props.reason) : '',
  );
  const [comments, setComments] = useState(props ? props.comments : '');
  const [decisionMaker, setDecisionMaker] = useState(
    props ? props.decisionMaker : '',
  );
  const [orderNumber, setOrderNumber] = useState(
    props ? props.orderNumber : '',
  );
  const [orderProductId, setOrderProductId] = useState(
    props ? props.orderProductId : '',
  );
  const [beerDes, setBeerDes] = useState(
    props
      ? `${props.orderProduct.materialNumber} ${props.orderProduct.description}`
      : '',
  );
  const [orderBatch, setOrderBatch] = useState(props ? props.orderBatch : '');
  const [expirityDate, setExpirityDate] = useState(
    props ? props.expirityDate : '',
  );
  const [BBT, setBBT] = useState(props ? props.BBT : '');
  const [beerLock, setBeerLock] = useState(props ? props.beerLock : '');
  const [typeLock, setTypeLock] = useState(props ? props.typeLock : '');
  const [typeLockDes, setTypeLockDes] = useState(
    props ? handleTypeLocks(props.typeLock) : '',
  );
  const [microCulture, setMicroCulture] = useState(
    props ? props.microCulture : false,
  );

  const [product, setProduct] = useState(props ? props.orderProduct : '');
  const [radioValue, setRadioValue] = useState(props ? props.beerLock : '');
  const [radioMicroCulture, setRadioMicroCulture] = useState(
    props ? (props.microCulture ? 'true' : 'false') : 'false',
  );
  const [dateFrom, setDateFrom] = useState(
    props && props.hourBlock.length > 0
      ? dayjs(props.hourBlock[0].dateFrom)
      : '',
  );
  const [dateTo, setDateTo] = useState(
    props && props.hourBlock.length > 0 ? dayjs(props.hourBlock[0].dateTo) : '',
  );
  const [microDateFrom, setMicroDateFrom] = useState(
    props && props.microbiologyCulture.length > 0
      ? dayjs(props.microbiologyCulture[0].dateFrom)
      : '',
  );
  const [microDateTo, setMicroDateTo] = useState(
    props && props.microbiologyCulture.length > 0
      ? dayjs(props.microbiologyCulture[0].dateTo)
      : '',
  );
  const [selectedBins, setSelectedBins] = useState(
    props ? handleSelectedBins(props.binBlock) : [],
  );

  const [releaseDate, setReleaseDate] = useState(
    props && props.releaseDate !== null ? dayjs(props.releaseDate) : null,
  );

  const beers = useSelector((state) => getBeers(state));

  const [binList, setBinList] = useState([]);

  const [ssccList, setSsccList] = useState(
    props ? handleSSCCList(props.ssccLock) : [],
  );
  const [loadBins, setLoadBins] = useState(false);
  const [endOrder, setEndOrder] = useState(props ? props.endOfOrder : false);
  /*
userId
typeReport
reason
warehouse
comments
decisionMaker
orderNumber
orderProductId
orderBatch
expirityDate
BBT
beerLock
typeLock 
microCulture => jezeli true to data posiewu
releaseDate => jezelu true to data uwolnienia
  */

  const handleEndORder = (val) => {
    console.log(val);
    setEndOrder(val);
    console.log(endOrder);
  };
  const handleClose = () => {
    setAlert(false);
  };

  useEffect(() => {
    const start = async () => {
      await dispatch(loadBeersRequest());
      const res = await dispatch(
        loadBinsByWarehouseRequest(user.users.warehouse),
      );
      setBinList(res.data);
    };
    start();
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newBins = [];
    const selectedSSCC = [];
    if (
      typeReport === '' ||
      reason === '' ||
      orderNumber === '' ||
      orderProductId === '' ||
      orderBatch === '' ||
      expirityDate === '' ||
      beerLock === '' ||
      typeLock === ''
    ) {
      setError(true);
      setAlert(true);
    } else {
      if (typeLock === 'BLOKADA_BINOW') {
        setSsccList([]);
        setDateFrom('');
        setDateTo('');
        selectedBins.map((el) => {
          newBins.push({
            binListId: el.id,
            statusBin: beerLock ? 'DO_ZABLOKOWANIA' : 'UWOLNIONE',
          });
        });
      } else if (typeLock === 'BLOKADA_SSCC') {
        setSelectedBins([]);
        setDateFrom('');
        setDateTo('');
        if (ssccList.length === 0) {
          setError(true);
          setAlert(true);
          return;
        } else {
          await ssccList.map((el) => {
            selectedSSCC.push({
              sscc: el,
              status: beerLock ? 'DO_ZABLOKOWANIA' : 'UWOLNIONE',
            });
          });
        }
      }

      console.log(releaseDate);

      action({
        userId: user.users.id,
        typeReport,
        reason,
        warehouse: user.users.warehouse,
        comments,
        decisionMaker: 'KONTROLER',
        orderNumber,
        orderProductId,
        orderBatch,
        expirityDate,
        BBT,
        beerLock,
        typeLock,
        microCulture,
        releaseDate: beerLock && releaseDate !== null ? releaseDate : null,
        microbiologyData: {
          dateFrom: microDateFrom,
          dateTo: microDateTo,
        },
        selectionBins: newBins.length > 0 ? newBins : null,
        ssccSelection: selectedSSCC.length > 0 ? selectedSSCC : null,
        hourData: {
          dateFrom,
          dateTo,
        },
        endOfOrder: endOrder,
        //   dateFrom,
        //   selectedBins,
        //   ssccList,
      });
    }
  };

  const handleProduct = async (id) => {
    if (id !== '') {
      beers.map((el) => {
        if (el.id === id) {
          setProduct(el);
        }
      });
    } else {
      setProduct('');
      setExpirityDate('');
      setOrderBatch('');
    }
  };

  const handleBeerLock = (e) => {
    setBeerLock(e.target.value === 'true' ? true : false);
    setRadioValue(e.target.value);
  };

  const handleMicroCulture = (e) => {
    setMicroCulture(e.target.value === 'true' ? true : false);
    setRadioMicroCulture(e.target.value);
  };

  const handleBatch = async (value) => {
    if (value.length === 7) {
      const expDate = await generateExpirationDateFromBatch(
        value,
        product.description,
        product.shelfLife,
      );

      setExpirityDate(dayjs(expDate));
      setDateFrom(dayjs(expDate));
      setDateTo(dayjs(expDate));

      const productionDate = await generateProductionDateFromBatch(value);
      setMicroDateFrom(dayjs(productionDate));
      setMicroDateTo(dayjs(productionDate));
    }
    setOrderBatch(value);
  };

  const handleSSCC = async (value) => {
    const sscc = value.split(/[,\n;.]/);

    setSsccList(sscc);
  };

  const handleRelaseDate = async (value) => {
    //obliczanie potencjalnej daty uwolnienia
    const godzina = new Date().getHours();

    if (
      (typeReport === 'RAPORT_NIEZGODNOSCI' ||
        typeReport === 'PODEJRZENIE_NIEZGODNOSCI') &&
      value === 'FIZ_CHEM'
    ) {
      if (godzina < 14) {
        setReleaseDate(dayjs(Date.now()).add(5, 'day'));
      } else {
        setReleaseDate(dayjs(Date.now()).add(6, 'day'));
      }
    } else if (typeReport === 'KWARANTANNA') {
      if (godzina < 14) {
        setReleaseDate(dayjs(Date.now()).add(3, 'day'));
      } else {
        setReleaseDate(dayjs(Date.now()).add(4, 'day'));
      }
    } else {
      setReleaseDate(null);
    }
  };

  const handleOrderNumber = (value) => {
    // tutaj dam pobieranie zlecenia z bazy
  };

  console.log(props);

  return (
    <Box sx={{ width: '100%' }}>
      {error && (
        <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            variant="filled"
            onClose={handleClose}
            severity="error"
            sx={{ width: '100%' }}
          >
            <AlertTitle>Error</AlertTitle>
            Uzupełnij wszystkie wymagane pola
          </Alert>
        </Snackbar>
      )}
      <h1>{actionText}</h1>
      <Divider sx={{ width: '100%', mb: 3, bgcolor: '#C09A53' }} />
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: { xs: 'flex', md: 'flex' },
          flexDirection: { xs: 'column', md: 'column' },
        }}
      >
        <h5>{t('pz04.data')}</h5>
        <Divider sx={{ width: '100%', mb: 3, bgcolor: '#C09A53' }} />
        <Box
          sx={{
            display: { xs: 'flex', md: 'flex' },
            flexDirection: { xs: 'column', md: 'row' },
            width: { xs: '100%', md: '100%' },
            mb: 3,
          }}
        >
          <Autocomplete
            disablePortal
            id="combo-source"
            options={typesReport.map((el) => ({
              id: el.value,
              label: el.label,
            }))}
            value={typeReportDes}
            sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
            onChange={(e, value) => (
              setTypeReport(value ? value.id : ''),
              setTypeReportDes(value ? value.label : '')
            )}
            renderInput={(params) => (
              <TextField {...params} label={t('pz04.type')} required />
            )}
          />
          <Autocomplete
            disablePortal
            id="combo-source"
            options={reasons.map((el) => ({
              id: el.value,
              label: el.label,
            }))}
            value={reasonDes}
            sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
            onChange={(e, value) => (
              setReason(value ? value.id : ''),
              setReasonDes(value ? value.label : ''),
              handleRelaseDate(value ? value.id : '')
            )}
            renderInput={(params) => (
              <TextField {...params} label={t('pz04.reason')} required />
            )}
          />
        </Box>
        <Box
          sx={{
            display: { xs: 'flex', md: 'flex' },
            flexDirection: { xs: 'column', md: 'row' },
            width: { xs: '100%', md: '100%' },
            mb: 3,
          }}
        >
          <TextField
            sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
            label={t('pz04.list.orderNumber')}
            inputProps={{ maxLength: 9 }}
            value={orderNumber}
            onChange={(e) => (
              handleOrderNumber(e.target.value), setOrderNumber(e.target.value)
            )}
          />
          {beers.length > 0 && (
            <Autocomplete
              disablePortal
              id="combo-source"
              options={beers.map((el) => ({
                id: el.id,
                label: `${el.materialNumber} ${el.description}`,
              }))}
              value={beerDes}
              sx={{ width: { xs: '100%', md: '50%' }, mb: 2, mx: 1 }}
              onChange={(e, value) => (
                setOrderProductId(value ? value.id : ''),
                setBeerDes(value ? value.label : ''),
                handleProduct(value ? value.id : '')
              )}
              renderInput={(params) => (
                <TextField {...params} label={t('pz04.dataProduct')} />
              )}
            />
          )}
        </Box>
        {product !== '' && (
          <Box
            sx={{
              display: { xs: 'flex', md: 'flex' },
              flexDirection: { xs: 'column', md: 'row' },
              width: { xs: '100%', md: '100%' },
              mb: 3,
            }}
          >
            <TextField
              sx={{ width: { xs: '100%', md: '40%' }, mb: 2, mx: 1 }}
              label={t('beer.brand')}
              disabled
              value={product.brand.description}
            />
            <TextField
              sx={{ width: { xs: '100%', md: '15%' }, mx: 1, mb: 2 }}
              variant="outlined"
              label={t('beer.batch')}
              value={orderBatch}
              onChange={(e) => handleBatch(e.target.value)}
            />
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DatePicker
                label={t('beer.expirationDate')}
                format="DD.MM.YYYY"
                views={['year', 'month', 'day']}
                value={dayjs(expirityDate)}
                onChange={(newValue) => {
                  setExpirityDate(dayjs(newValue));
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <TextField
              sx={{ width: { xs: '100%', md: '15%' }, mx: 1, mb: 2 }}
              variant="outlined"
              label={t('pz04.list.BBT')}
              value={BBT}
              onChange={(e) => setBBT(e.target.value)}
            />
          </Box>
        )}
        <Box
          sx={{
            display: { xs: 'flex', md: 'flex' },
            flexDirection: { xs: 'column', md: 'row' },
            width: { xs: '100%', md: '100%' },
            mb: 3,
          }}
        >
          <TextareaAutosize
            style={{
              marginLeft: '7px',
              width: '50%',
              height: '150px',
              overflow: 'auto',
            }}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder={t('pz04.commentsPlaceholder')}
          />
        </Box>
        <h5>{t('pz04.details')}</h5>
        <Divider sx={{ width: '100%', mb: 3, bgcolor: '#C09A53' }} />

        <Autocomplete
          disablePortal
          id="combo-source"
          options={typesLocks.map((el) => ({
            id: el.value,
            label: el.label,
          }))}
          value={typeLockDes}
          sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
          onChange={(e, value) => (
            setTypeLock(value ? value.id : ''),
            setTypeLockDes(value ? value.label : ''),
            handleTypeLock(value ? value.id : '')
          )}
          renderInput={(params) => (
            <TextField {...params} label={t('pz04.typeLock')} required />
          )}
        />

        {typeLock === 'BLOKADA_GODZIN' && (
          <Box
            sx={{
              display: { xs: 'flex', md: 'flex' },
              flexDirection: { xs: 'column', md: 'row' },
              width: { xs: '100%', md: '100%' },
              mb: 3,
            }}
          >
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                label={t('pz04.hourBlockFrom')}
                format="DD.MM.YYYY HH"
                views={['year', 'month', 'day', 'hours']}
                value={dayjs(dateFrom)}
                onChange={(newValue) => {
                  setDateFrom(dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {!endOrder && (
              <LocalizationProvider
                adapterLocale="pl"
                dateAdapter={AdapterDayjs}
              >
                <DateTimePicker
                  sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                  label={t('pz04.hourBlockTo')}
                  format="DD.MM.YYYY HH"
                  views={['year', 'month', 'day', 'hours']}
                  value={dayjs(dateTo)}
                  onChange={(newValue) => {
                    setDateTo(dayjs(newValue));
                  }}
                  slotProps={{
                    textField: {
                      error: false,
                    },
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            )}
            <FormGroup>
              <FormControlLabel
                sx={{ ml: 1, mt: 1 }}
                control={
                  <Checkbox
                    checked={endOrder}
                    onChange={() => handleEndORder(!endOrder)}
                  />
                }
                label={t('pz04.endOfOrder')}
              />
            </FormGroup>
          </Box>
        )}
        {typeLock === 'BLOKADA_BINOW' && (
          <Autocomplete
            sx={{ width: { xs: '100%', md: '40%' }, mb: 2, mx: 1 }}
            multiple
            id="tags-standard"
            options={binList}
            value={selectedBins}
            getOptionLabel={(option) => option.binName}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={t('pz04.binList')}
                placeholder="Bin"
              />
            )}
            onChange={(e, value) => setSelectedBins(value)}
          />
        )}
        {typeLock === 'BLOKADA_SSCC' && (
          <TextareaAutosize
            style={{
              marginLeft: '7px',
              width: '50%',
              height: '150px',
              overflow: 'auto',
            }}
            value={ssccList.join('\n')}
            placeholder={t('pz04.ssccPlaceholder')}
            onChange={(e) => handleSSCC(e.target.value)}
            required
          />
        )}
        <Box
          sx={{
            display: { xs: 'flex', md: 'flex' },
            flexDirection: { xs: 'column', md: 'row' },
            width: { xs: '100%', md: '100%' },
            mb: 3,
            mx: 1,
            mt: 1,
          }}
        >
          <FormControl>
            <FormLabel>Status</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={radioValue}
              onChange={handleBeerLock}
            >
              <FormControlLabel
                value="true"
                control={<Radio required />}
                label={t('pz04.beerLocked')}
              />
              <FormControlLabel
                value="false"
                control={<Radio required />}
                label={t('pz04.beerUnlocked')}
              />
            </RadioGroup>
          </FormControl>
        </Box>
        {reason === 'MIKROBIOLOGIA' && (
          <Box
            sx={{
              display: { xs: 'flex', md: 'flex' },
              flexDirection: { xs: 'column', md: 'row' },
              width: { xs: '100%', md: '100%' },
              mb: 3,
              mx: 1,
            }}
          >
            <FormControl>
              <FormLabel>{t('pz04.dataMicroCulture')}</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={radioMicroCulture}
                onChange={handleMicroCulture}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label={t('pz04.yes')}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label={t('pz04.no')}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        )}
        {microCulture && reason === 'MIKROBIOLOGIA' && (
          <Box
            sx={{
              display: { xs: 'flex', md: 'flex' },
              flexDirection: { xs: 'column', md: 'row' },
              width: { xs: '100%', md: '100%' },
              mb: 3,
            }}
          >
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                label={t('pz04.microDateFrom')}
                format="DD.MM.YYYY HH"
                views={['year', 'month', 'day', 'hours']}
                value={dayjs(microDateFrom)}
                onChange={(newValue) => {
                  setMicroDateFrom(dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                label={t('pz04.microDateTo')}
                format="DD.MM.YYYY HH"
                views={['year', 'month', 'day', 'hours']}
                value={dayjs(microDateTo)}
                onChange={(newValue) => {
                  setMicroDateTo(dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
        )}
        {(((typeReport === 'RAPORT_NIEZGODNOSCI' ||
          typeReport === 'PODEJRZENIE_NIEZGODNOSCI') &&
          reason === 'FIZ_CHEM' &&
          beerLock) ||
          (typeReport === 'KWARANTANNA' && beerLock)) && (
          <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
            <DateTimePicker
              sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
              label={t('pz04.releaseDate')}
              format="DD.MM.YYYY"
              views={['year', 'month', 'day']}
              value={dayjs(releaseDate)}
              onChange={(newValue) => {
                setReleaseDate(dayjs(newValue));
              }}
              slotProps={{
                textField: {
                  error: false,
                },
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        )}

        <Button
          sx={{
            color: 'white',
            bgcolor: '#C09A53',
            ':hover': { bgcolor: '#9c7c43' },
            height: '40px',
            width: '150px',
            mt: 2,
          }}
          type="submit"
        >
          {t('button.confirmButton')}
        </Button>
      </Box>
    </Box>
  );
};

export default ReportPZ04Form;
